import React, { useRef, useState, useCallback, useMemo } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import { useDispatch } from 'react-redux';
import PresetSelector from './PresetSelector';
import ScheduleTable168 from '../../../components/Schedule/ScheduleTable168';
import PresetFormSimple from './PresetFormSimple';
import { setSelectedSinglePreset } from 'stores/sensor/controllersSlice';
import SaveIcon from '@mui/icons-material/Save';

const EditSchedulePatternsContainer = ({
  scheduleTableRef,
  onPatternsChange,
  showRelayPresets,
  devices = [],
}) => {
  const dispatch = useDispatch();
  const [removeMode, setRemoveMode] = useState(false);
  const fallbackScheduleTableRef = useRef(null);
  const effectiveScheduleTableRef = scheduleTableRef ?? fallbackScheduleTableRef;
  const shouldShowRelayPresets = useMemo(() => {
    if (Array.isArray(devices) && devices.length > 0) {
      return devices.every(device =>
        String(device?.device_type ?? '')
          .toLowerCase()
          .includes('relay'),
      );
    }

    return Boolean(showRelayPresets);
  }, [devices, showRelayPresets]);
  const handleUserEdit = useCallback(() => {
    onPatternsChange?.();
  }, [onPatternsChange]);

  // const handleToggleRemoveMode = useCallback(() => {
  //   setRemoveMode(prev => {
  //     const next = !prev;
  //     if (next) {
  //       dispatch(setSelectedSinglePreset(null));
  //     }
  //     return next;
  //   });
  // }, [dispatch]);

  return (
    <>
      <PresetSelector
        removeMode={removeMode}
        setRemoveMode={setRemoveMode}
        showRelayPresets={shouldShowRelayPresets}
        devices={devices}
      />
      <ScheduleTable168
        ref={effectiveScheduleTableRef}
        removeMode={removeMode}
        showRelayPresets={shouldShowRelayPresets}
        onUserEdit={handleUserEdit}></ScheduleTable168>
      <PresetFormSimple showRelayPresets={shouldShowRelayPresets} />
    </>
  );
};
export default EditSchedulePatternsContainer;
